import React from 'react';
import autoBind from 'react-autobind';
import BaseComponent from '@common/components/base.component';
import api from '../service/sede.service';
import * as S from './index.container.styles';

class Layout extends BaseComponent {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      conteudoTelaInicial: 'Carregando...',
    };
  }

  async componentDidMount() {
    const conteudoTelaInicial = await api.getTemplateTelaInicial();
    this.setState({ conteudoTelaInicial });
  }

  render() {
    const { conteudoTelaInicial } = this.state;

    return <S.HomeContainer dangerouslySetInnerHTML={{ __html: conteudoTelaInicial }} />;
  }
}

export default Layout;
